import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Typography, 
  Paper, 
  Box, 
  Button, 
  CircularProgress,
  Alert
} from '@mui/material';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import MainLayout from '../components/layouts/MainLayout';

/**
 * Page for unsubscribing from email advertisements
 */
const UnsubscribePage = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [email, setEmail] = useState('');

  useEffect(() => {
    const unsubscribe = async () => {
      try {
        setLoading(true);
        
        const response = await axios.get(`/api/subscribers/email/unsubscribe/${token}`);
        
        setSuccess(true);
        setEmail(response.data.email);
      } catch (err) {
        console.error('Error unsubscribing:', err);
        setError(err.response?.data?.error || 'Ошибка при отписке от рассылки');
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      unsubscribe();
    } else {
      setLoading(false);
      setError('Токен отписки не найден');
    }
  }, [token]);

  return (
    <MainLayout>
      <Container maxWidth="md" sx={{ py: 5 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Box sx={{ textAlign: 'center', py: 2 }}>
            {loading ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                <CircularProgress />
                <Typography variant="h6">Обработка запроса на отписку...</Typography>
              </Box>
            ) : success ? (
              <>
                <Typography variant="h4" component="h1" gutterBottom>
                  Вы успешно отписались от рассылки
                </Typography>
                <Alert severity="success" sx={{ mb: 3 }}>
                  Адрес {email} больше не будет получать рекламные рассылки от нас
                </Alert>
                <Typography variant="body1" paragraph>
                  Мы сожалеем, что вы решили отписаться от нашей рассылки. 
                  Если у вас есть пожелания или предложения по улучшению нашего сервиса, 
                  пожалуйста, сообщите нам об этом.
                </Typography>
                <Button 
                  variant="contained" 
                  color="primary" 
                  component={Link} 
                  to="/"
                  sx={{ mt: 2 }}
                >
                  Вернуться на главную
                </Button>
              </>
            ) : (
              <>
                <Typography variant="h4" component="h1" gutterBottom color="error">
                  Ошибка при отписке
                </Typography>
                <Alert severity="error" sx={{ mb: 3 }}>
                  {error}
                </Alert>
                <Typography variant="body1" paragraph>
                  Произошла ошибка при обработке вашего запроса на отписку. 
                  Пожалуйста, проверьте правильность ссылки или попробуйте позже.
                </Typography>
                <Button 
                  variant="contained" 
                  color="primary" 
                  component={Link} 
                  to="/"
                  sx={{ mt: 2 }}
                >
                  Вернуться на главную
                </Button>
              </>
            )}
          </Box>
        </Paper>
      </Container>
    </MainLayout>
  );
};

export default UnsubscribePage;
